export default {
    name: 'redirects.landing-page',
    path: '/conheca',
    component: () => import(/* webpackChunkName: "welcome" */ '@/views/redirect/RedirectToLandingPage.vue'),
}